/**
 * Kerning
 * 単純にテキストノードを取って役モノと直前文字をspanで包含後、置換する
 */
import VueKerning from './directive'

export default {
  install(Vue, options) {

    Vue.directive('kerning', VueKerning)
  }
}


// WEBPACK FOOTER //
// ./src/plugins/kerning/index.js